<template>
  <section class="page-callout module">
    <div class="container">
      <div
        class="image-container inner-container relative flex flex-col items-center">
        <img
          class="min-h-[350px] w-full object-cover p-8 lg:p-0"
          :src="
            device === 'mobile'
              ? data.img_mobile.url
              : data.page_callout_image.url
          "
          :alt="data?.page_callout_image?.alt || 'page callout image'" />
        <div
          class="relative bottom-[100px] flex w-full max-w-[1190px] items-center justify-center
            p-xs lg:absolute lg:bottom-[-50px] lg:p-0">
          <BlurBG
            theme="dark"
            :blob-size="1.1">
            <template #default>
              <div class="pc-content-container">
                <div
                  v-if="data.page_callout_headline"
                  class="title"
                  v-html="data.page_callout_headline"></div>
                <div
                  v-if="data.page_callout_text"
                  class="text editor-formatting"
                  v-html="data.page_callout_text"></div>
                <div class="button-section mx-auto w-fit">
                  <ArrowCircleButton
                    :link="data.page_callout_link"
                    color="white" />
                </div>
              </div>
            </template>
          </BlurBG>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "PageCalloutComponent",
    "CLASSNAME": "page-callout",
    "URL": "http://local.bicara.com/"
   }
  #ENDMETA */

import useUtils from '@/composables/useUtils'
import ArrowCircleButton from '@/components/utility/ArrowCircleButton.vue'
import BlurBG from '../utility/BlurBG.vue'

const { device } = useUtils()

defineProps(['data'])
</script>

<style lang="scss">
.page-callout {
  @apply bg-bicara-white pt-7 lg:pt-16;
  padding-bottom: 120px !important;
  @include mobile {
    padding-bottom: 0px !important;
  }

  .image-container {
    position: relative;

    .pc-content-container {
      position: relative;
      width: 100%;
      padding: 50px;
      border-radius: 24px;
      text-align: center;
      color: $white;
      @include mobile {
        padding: 30px;
      }
      .title {
        * {
          @apply header-3;
          strong {
            @apply text-bicara-turquoise;
          }
        }
      }

      .text {
        max-width: 1000px;
        margin: 30px auto 0;
        * {
          @apply body-md;
        }
      }

      .button-section {
        .link {
          @apply pl-[20px] pr-[80px] lg:pl-lg lg:pr-[100px];
        }
      }

      .btn {
        margin: 40px 0 0;
      }
    }
  }
}
</style>
